import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tabs,
  Tab,
  Autocomplete,
  Button,
  Icon,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import PercentIcon from "@mui/icons-material/Percent";

const ReturnItemList = ({
  rows,
  decrementFetchQty,
  selectedOpenMenuIndex,
  anchorElItem,
  openItem,
  handleCloseItem,
  handleDiscountClickItem,
  handleSalesmanClickItem,
  handleEditPriceClickItem,
  openEditPriceItem,
  handleCloseEditPriceItem,
  handleEditPriceItem,
  applyPriceItem,
  openSalesmanItem,
  handleCloseSalesmanItem,
  salesman,
  autocompletesalesmanValueItem,
  handleAutocompleteChangeItem,
  applySalesmanItem,
  handleRemoveSelectedItem,
  openModalItem,
  handleCloseModalItem,
  calculateDiscountItem,
}) => {
  if (!rows || rows.length === 0) return <div>No items to return</div>;

  const itemsToReturn = rows.filter((item) => item.quantity >= 1);

  if (itemsToReturn.length === 0)
    return (
      <div className="flex justify-center items-center">
        All items have been returned.
      </div>
    );
  console.log("itemsToReturn", itemsToReturn);
  console.log("rows", rows);

  return (
    <div>
      {itemsToReturn.map((item, index) => (
        <div
          key={index}
          className="border text-sm border-gray-300 p-2 rounded-lg flex justify-between items-center mb-2"
        >
          <div className="w-[35%]">
            <p className=" text-xs">{item.item_name}</p>
          </div>

          <div className="w-[80px] flex flex-row items-center justify-between space-x-.5">
            <IconButton
              onClick={() => decrementFetchQty(item.id)}
              disabled={item.quantity === 0}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>
            <p>{item.quantity}</p>
            <IconButton disabled>
              <AddIcon fontSize="small" />
            </IconButton>
          </div>

          <div className="w-[15%]">
            {item.price && (
              <p className="text-gray-500 ml-4 text-xs">
                Price: {Number(item.price).toFixed(2)}
              </p>
            )}
          </div>

          <div className="w-[15%]">
            {item.price && (
              <p className="text-gray-500 ml-4 text-xs">
                Net Price: {Number(item.net).toFixed(2)}
              </p>
            )}
          </div>

          <div className="w-[20%]">
            {item.price && (
              <p className="text-gray-500 ml-4 text-xs">
                VAT:{" "}
                {Number(
                  (item.net *
                    item.quantity *
                    item?.newValue?.tax_master_1?.taxcal) /
                    100
                ).toFixed(2)}
              </p>
            )}
          </div>

          <div className="w-[10%]">
            {item.price && (
              <p className="text-gray-500 ml-4 text-xs">
                Total: {Number(item.item_grand_total).toFixed(2)}
              </p>
            )}
          </div>

          <div className="w-[10%]">
            <div className="ml-4">
              {selectedOpenMenuIndex === index && (
                <Menu
                  anchorEl={anchorElItem}
                  id="action-menu"
                  open={openItem}
                  onClose={handleCloseItem}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem onClick={() => handleDiscountClickItem(index)}>
                    <Icon fontSize="small">%</Icon> Discount
                  </MenuItem>
                  <MenuItem onClick={() => handleSalesmanClickItem(index)}>
                    <Icon fontSize="small">user</Icon> Salesman
                  </MenuItem>
                  <MenuItem onClick={() => handleEditPriceClickItem(index)}>
                    <Icon fontSize="small">edit</Icon> Price
                  </MenuItem>
                  <MenuItem onClick={() => handleRemoveSelectedItem(item.id)}>
                    <Icon fontSize="small">delete</Icon> Remove
                  </MenuItem>
                </Menu>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReturnItemList;
